export const appendLeadingZeroes = (n: number) => {
  if (n <= 9) {
    return '0' + n;
  }
  return n;
};
